export const Constants = {
	//Tipos de módulos (en base al id en la tabla t_modules)
	MODULE_HOME: 0,
	MODULE_USERS: 1,
	MODULE_CONFIGS: 2,
	MODULE_ASSESSMENTS: 3,

	//Estados de las evaluaciones
	AS_PENDING_STATUS: -1,
	AS_IN_PROGRESS_STATUS: 0,
	AS_FINISHED_STATUS: 1,
	
	//Estados de los módulos de las evaluaciones
	MO_PENDING_STATUS: -1,
	MO_FINISHED_STATUS: 0,
	MO_PROCESSED_STATUS: 1,
}